export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6123.2fc69f58.jpg";